<template>
  <form @submit.prevent="$emit('search')">
    <TextInput
      :modelValue="modelValue"
      :label="label"
      :placeHolder="placeHolder"
      @update:modelValue="(value) => $emit('update:modelValue', value)"
    >
      <template #after>
        <button
          v-if="modelValue"
          type="button"
          class="btn btn-outline-secondary"
          title="Clear search"
          @click="$emit('clear')"
        >
          <i class="bi bi-x-lg" />
        </button>
        <button
          type="submit"
          class="btn btn-primary"
        >
          Search
        </button>
      </template>
    </TextInput>
  </form>
</template>

<script>
import TextInput from '@/components/common/TextInput';

export default {
  components: {
    TextInput,
  },
  props: [ 'modelValue', 'label', 'placeHolder' ],
  emits: [ 'update:modelValue', 'search', 'clear' ],
};
</script>
